var PaneItemViewModel, PaneViewModel;

PaneItemViewModel = (function() {
  function PaneItemViewModel(item) {
    var toggleExpanded;
    this.rawItem = item;
    this.id = this.rawItem.id;
    if (this.id == null) {
      throw 'A Pane Item must have an id.';
    }
    this.name = this.rawItem.name;
    if (ko.unwrap(this.name) == null) {
      throw 'A Pane Item must have a name.';
    }
    this.href = this.rawItem.href;
    if (ko.unwrap(this.href) == null) {
      throw 'A Flyout Menu Item must have a href.';
    }
    this.icons = ko.pureComputed((function(_this) {
      return function() {
        return ko.unwrap(_this.rawItem.icons) || [];
      };
    })(this));
    this.statusClass = ko.pureComputed((function(_this) {
      return function() {
        return ko.unwrap(_this.rawItem.statusClass) || '';
      };
    })(this));
    this.items = ko.pureComputed((function(_this) {
      return function() {
        return ko.unwrap(_this.rawItem.items || []).map(function(i) {
          return new PaneItemViewModel(i);
        });
      };
    })(this));
    this.isSelected = ko.observable(false);
    this.isExpanded = ko.observable(false);
    this.isChildSelected = ko.computed((function(_this) {
      return function() {
        var result;
        result = false;
        _this.items().forEach(function(i) {
          if (i.isSelected() || i.isChildSelected()) {
            return result = true;
          }
        });
        return result;
      };
    })(this));
    ko.computed((function(_this) {
      return function() {
        if (_this.isSelected() || _this.isChildSelected()) {
          return _this.isExpanded(true);
        }
      };
    })(this));
    toggleExpanded = (function(_this) {
      return function() {
        return _this.isExpanded(!_this.isExpanded());
      };
    })(this);
    this.hasItems = ko.pureComputed((function(_this) {
      return function() {
        return helpers.hasItems(_this.items);
      };
    })(this));
    this.caretIcon = ko.pureComputed((function(_this) {
      return function() {
        if (_this.hasItems) {
          if (_this.isExpanded()) {
            return '#icon-caret-down';
          } else {
            return '#icon-caret-right';
          }
        } else {
          return '';
        }
      };
    })(this));
    this.onClick = (function(_this) {
      return function(data, event) {
        if ($(event.target).is('use, svg')) {
          toggleExpanded();
          return false;
        }
        return true;
      };
    })(this);
  }

  return PaneItemViewModel;

})();

PaneViewModel = (function() {
  function PaneViewModel(options, element) {
    var _doExpandOrCollapse, _doSearch, _doSelection, expandOrCollapse, selectedItem;
    options = $.extend({
      itemTemplateName: 'cyclops.paneItem',
      itemFilteredTemplateName: 'cyclops.paneItemFiltered',
      emptyTemplateName: 'cyclops.paneEmpty',
      loadingTemplateName: 'cyclops.paneItemsLoading',
      loading: false,
      headerTemplateName: 'cyclops.paneHeader',
      maxSearchResults: 20,
      searchComparer: function(item, query) {
        return ko.unwrap(item.name).toLowerCase().indexOf(query) > -1;
      }
    }, options);
    this.rawItems = ko.asObservable(options.items || []);
    this.items = ko.computed((function(_this) {
      return function() {
        return _this.rawItems().map(function(i) {
          return new PaneItemViewModel(i);
        });
      };
    })(this));
    this.bodyTemplateName = ko.pureComputed((function(_this) {
      return function() {
        if (ko.unwrap(options.loading)) {
          return options.loadingTemplateName;
        } else if (_this.rawItems().length < 1) {
          return options.emptyTemplateName;
        } else {
          return 'cyclops.paneForeach';
        }
      };
    })(this));
    selectedItem = ko.asObservable(options.selectedItemId);
    _doSelection = function(item, id) {
      item.isSelected(item.id === id);
      return item.items().forEach(function(i) {
        return _doSelection(i, id);
      });
    };
    ko.computed((function(_this) {
      return function() {
        return _this.items().forEach(function(i) {
          return _doSelection(i, selectedItem());
        });
      };
    })(this));
    _doExpandOrCollapse = function(item, shouldExpand) {
      item.isExpanded(shouldExpand);
      return item.items().forEach(function(i) {
        return _doExpandOrCollapse(i, shouldExpand);
      });
    };
    expandOrCollapse = (function(_this) {
      return function(shouldExpand) {
        return _this.items().forEach(function(i) {
          return _doExpandOrCollapse(i, shouldExpand);
        });
      };
    })(this);
    this.expandAll = function() {
      return expandOrCollapse(true);
    };
    this.collapseAll = function() {
      return expandOrCollapse(false);
    };
    this.headerTemplateName = options.headerTemplateName;
    this.itemTemplateName = ko.pureComputed((function(_this) {
      return function() {
        if (_this.isSearching()) {
          return options.itemFilteredTemplateName;
        } else {
          return options.itemTemplateName;
        }
      };
    })(this));
    this.displayItems = ko.pureComputed((function(_this) {
      return function() {
        if (_this.isSearching()) {
          return _this.filteredItems().slice(0, options.maxSearchResults);
        } else {
          return _this.items();
        }
      };
    })(this));
    this.paneSearchMessage = ko.pureComputed((function(_this) {
      return function() {
        var maxLength;
        maxLength = ko.unwrap(options.maxSearchResults);
        if (_this.isSearching() && maxLength < _this.filteredItems().length) {
          return "showing " + maxLength + " of " + (_this.filteredItems().length) + " results.";
        } else if (_this.filteredItems().length === 0) {
          return 'no results';
        } else {
          return 'showing all results';
        }
      };
    })(this));
    this.searchQuery = ko.observable('');
    this.isSearching = ko.pureComputed((function(_this) {
      return function() {
        return _this.searchQuery() !== '';
      };
    })(this));
    this.showSearchbox = ko.observable(false);
    this.toggleSearch = (function(_this) {
      return function(data, event) {
        _this.searchQuery('');
        _this.showSearchbox(!_this.showSearchbox());
      };
    })(this);
    _doSearch = function(item, query, result) {
      if (options.searchComparer(item, query)) {
        result.push(item);
      }
      return item.items().forEach(function(i) {
        return _doSearch(i, query, result);
      });
    };
    this.filteredItems = ko.pureComputed((function(_this) {
      return function() {
        var result;
        result = [];
        if (_this.isSearching()) {
          _this.items().forEach(function(i) {
            return _doSearch(i, _this.searchQuery().toLowerCase(), result);
          });
        }
        return result;
      };
    })(this));
    this.togglePane = function() {
      return $(element).toggleClass('pane-expanded');
    };
    $(element).affix();
  }

  return PaneViewModel;

})();
